const nav_bar = {
	overview: "Overview",
};

export default nav_bar;
